<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="exchange-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-swap-horizontal</v-icon>
                  <h1 class="header-title">Token Exchange</h1>
                </div>
                <p class="header-subtitle">
                  Trade tokens with other users on the decentralized exchange
                </p>
                <div class="header-actions">
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-refresh"
                    @click="refreshData()"
                    class="action-btn"
                  >
                    Refresh
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-cash-plus"
                    @click="buyOffer()"
                    class="action-btn"
                  >
                    Buy Offer
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-cash-minus"
                    @click="sellOffer()"
                    class="action-btn"
                  >
                    Sell Offer
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Filters Section -->
              <div class="filters-section">
                <h2 class="section-title">
                  <v-icon left>mdi-filter</v-icon>
                  Transaction Filters
                </h2>

                <div class="filters-wrapper">
                  <v-checkbox
                    v-model="allStats"
                    color="white"
                    hide-details
                    class="filter-checkbox"
                  >
                    <template v-slot:label>
                      <span class="checkbox-label">Show All Transactions</span>
                    </template>
                  </v-checkbox>

                  <div class="date-range-picker">
                    <v-menu
                      :disabled="allStats"
                      v-model="menuFrom"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateFrom"
                          label="From Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuFrom = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFrom"
                        :max="dateTo"
                        @update:model-value="menuFrom = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>

                    <v-menu
                      :disabled="allStats"
                      v-model="menuTo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateTo"
                          label="To Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuTo = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateTo"
                        :min="dateFrom"
                        :max="new Date()"
                        @update:model-value="menuTo = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Chart Section -->
              <div class="chart-section">
                <h2 class="section-title">
                  <v-icon left>mdi-chart-line</v-icon>
                  Price History
                </h2>

                <div class="chart-wrapper">
                  <canvas id="priceChart"></canvas>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Buy Offers Section -->
              <div class="offers-section">
                <h2 class="section-title">
                  <v-icon left>mdi-cash-plus</v-icon>
                  Buy Offers
                </h2>

                <div class="offers-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-cash-plus</v-icon>
                  </div>
                  <p class="empty-text">No active buy offers at the moment</p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Sell Offers Section -->
              <div class="offers-section">
                <h2 class="section-title">
                  <v-icon left>mdi-cash-minus</v-icon>
                  Sell Offers
                </h2>

                <div class="offers-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="48" color="grey">mdi-cash-minus</v-icon>
                  </div>
                  <p class="empty-text">No active sell offers at the moment</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(isMobileXs || isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-date-fns';
Chart.register(...registerables);
import { markRaw } from 'vue'

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Exchange',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    searchQuery: "",
    menuFrom: false,
    menuTo: false,
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(),
    allStats: true,

    transactions: [],
    chart: null,

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    formattedDateFrom() {
      return this.dateFrom.toLocaleDateString();
    },
    formattedDateTo() {
      return this.dateTo.toLocaleDateString();
    },

  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.$store.dispatch('getTransactions', { uid: this.user.uid, token: this.user.token, from: this.dateFrom.toISOString(), to: this.dateTo.toISOString() }).then(response => {
        this.transactions = this.$store.getters.getTransactions;
        this.drawChart();
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Error occured.. Please try again later.");
        }
      })

    }
  },
  methods: {
    refreshData() {
      this.$store.dispatch('getTransactions', { uid: this.user.uid, token: this.user.token, from: this.dateFrom.toISOString(), to: this.dateTo.toISOString() }).then(response => {
        this.transactions = this.$store.getters.getTransactions;
        this.drawChart();
        this.notify('Data refreshed successfully!');
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Error occured.. Please try again later.");
        }
      })
    },
    buyOffer() {
      this.notify('Buy offer feature coming soon!');
    },
    sellOffer() {
      this.notify('Sell offer feature coming soon!');
    },
    drawChart() {
      const ctx = document.getElementById('priceChart').getContext('2d');
      const labels = this.transactions.map(tx => new Date(tx.timestamp));
      const data = this.transactions.map(tx => tx.price);

      if (this.chart) {
        this.chart.destroy();
      }

      var charted = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [{
            label: 'Price (USD)',
            data: data,
            borderColor: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 3,
            pointHoverRadius: 5,
            pointBackgroundColor: 'white',
            pointBorderColor: 'white',
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
              },
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
              ticks: {
                color: 'rgba(255, 255, 255, 0.7)',
                font: {
                  family: 'Darker Grotesque',
                  size: 12,
                }
              }
            },
            y: {
              beginAtZero: false,
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
              ticks: {
                color: 'rgba(255, 255, 255, 0.7)',
                font: {
                  family: 'Darker Grotesque',
                  size: 12,
                }
              }
            },
          },
          plugins: {
            legend: {
              labels: {
                color: 'white',
                font: {
                  family: 'Darker Grotesque',
                  size: 14,
                  weight: '600'
                }
              }
            },
            tooltip: {
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              titleColor: 'white',
              bodyColor: 'white',
              borderColor: 'rgba(255, 255, 255, 0.2)',
              borderWidth: 1,
              titleFont: {
                family: 'Darker Grotesque',
                size: 14,
                weight: '600'
              },
              bodyFont: {
                family: 'Darker Grotesque',
                size: 13,
              },
              callbacks: {
                label: function (context) {
                  const transaction = context.chart.data.datasets[0].data[context.dataIndex];
                  const volume = this.transactions[context.dataIndex].volume;
                  const type = this.transactions[context.dataIndex].type.toUpperCase();
                  return [
                    `Price: $${transaction}`,
                    `Volume: ${volume}`,
                    `Type: ${type}`
                  ];
                }.bind(this)
              }
            }
          }
        },
      });
      this.chart = markRaw(charted)
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Exchange Header */
.exchange-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

/* Section Title */
.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Filters Section */
.filters-section {
  margin-bottom: 24px;
}

.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-checkbox {
  :deep(.v-label) {
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    color: white !important;
  }
}

.checkbox-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.date-range-picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 600px) {
  .date-range-picker {
    grid-template-columns: 1fr;
  }
}

.date-field {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.date-field .v-field:hover:not(.v-field--disabled)) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.date-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.date-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

:deep(.date-field.v-field--disabled .v-field) {
  opacity: 0.5;
}


/* Chart Section */
.chart-section {
  margin-bottom: 24px;
}

.chart-wrapper {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
}

.chart-wrapper:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

#priceChart {
  max-height: 400px;
}

/* Offers Section */
.offers-section {
  margin-bottom: 24px;
}

.offers-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.empty-icon-wrapper {
  margin-bottom: 16px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.exchange-header,
.filters-section,
.chart-section,
.offers-section {
  animation: slideIn 0.4s ease forwards;
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
  }

  .chart-wrapper {
    padding: 16px;
  }

  #priceChart {
    max-height: 300px;
  }
}

</style>